import EditTrip from "./EditTrip";

export default EditTrip;
